(function ($, window) {
    'use strict';

    var contactForm = $('.scfForm');
    var successMessage = $('#success-message');
    var errorMessage = $('#error-message');

    var contactName = $('#contact-name');

    var contactEmail = $('#contact-email');
    var contactEmailError = $('#contact-email-error');

    var contactComment = $('#contact-comment');

    var submitButton = $('#contact-submit');

    if (!contactForm) {
        return;
    }

    contactForm.submit(function (e) {
        e.preventDefault();

        if (validateInputRequired(contactEmail, contactEmailError, 'Email is required.')
            && validateInputEmail(contactEmail, contactEmailError, 'Please provide a valid email address.')) {
            var name = contactName.val();
            var email = contactEmail.val();
            var comment = contactComment.val();
            submitButton.attr("disabled", true);

            grecaptcha.execute(window.shook.recaptchaSiteKey, { action: 'contactus' }).then(function (token) {
                $.ajax({
                    type: "POST",
                    url: "/api/sitecore/GeneralContentPageFrame/SubmitContactUs",
                    data: {
                        'name': name,
                        'email': email,
                        'comments': comment,
                        'recaptchaResponse': token
                    },
                    success: function (data) {
                        if (data.Success) {
                            successMessage.show();
                            contactForm.hide();
                        } else {
                            errorMessage.text(data.Message);
                        }
                    },
                    error: function () {
                        errorMessage.text('An error has occurred.');
                    }
                });
            }, function (reject) {
                errorMessage.text('An error has occurred.');
            });
        }
    });

    function validateInputRequired(input, error, errorMsg) {
        error.text('');

        if (!input.val()) {
            error.text(errorMsg);
            return false;
        }

        return true;
    }

    function validateInputEmail(input, error, errorMsg) {
        error.text('');

        var regex = /^([\w\.\-]+)@([\w\-]+)\.([\w]{2,})$/gi;
        var emailTest = regex.test(input.val());
        if (!emailTest) {
            error.text(errorMsg);
            return false;
        } else {
            return true;
        }
    }
})(jQuery, window);